module.exports = __webpack_public_path__ + "static/media/apple-store.e71655ae.svg";